$('document').ready(function() {
    $('.awards--accordion__title input[type=checkbox]').change(function() {
        $item = $(this).parent().next();
        $toggle = $(this).parent().find('.awards--accordion__toggle');

        if($item.hasClass('open') && !$(this).is(':checked')) {
            $item.removeClass('open');
            $toggle.removeClass('open');
        } else {
            if($(this).is(':checked')) {
                $item.addClass('open');
                $toggle.addClass('open');
            }
        }

        if($(this).is(':checked')) {
            $item.find('input, textarea').prop('required', true);
        } else {
            $item.find('input, textarea').prop('required', false);
        }
    });

    $('.awards--accordion__toggle').click(function(e) {
        $item = $(this).parent().next();
        $checkbox = $(this).parent().find('input[type=checkbox]');

        if($item.hasClass('open')) {
            $item.removeClass('open');
            $(this).removeClass('open');
        } else {
            $item.addClass('open');
            $(this).addClass('open');
        }
    });

    $('.awards--accordion__content input, .awards--accordion__content textarea').blur(function() {
        if($(this).val()) {
            $(this).parent().siblings('.awards--accordion__title').find('input[type=checkbox]').prop('checked', true);
        }
    });
});
